module.exports = __webpack_public_path__ + "public/img/wuyut_gywm.dee5a28d.jpg";